<template>
  <div>
    <div class="row push">
      <div class="col-lg-5 col-xl-4 order-lg-1">
        <!-- Shopping Cart -->
        <div class="block block-mode-loading-oneui" :class="{ 'block-mode-loading': loading }">
          <div class="block-header block-header-default">
            <h3 class="block-title">Bestelling</h3>
          </div>
          <div class="block-content" v-if="$_.isEmpty(cart) || (cart && cart.cart_items && cart.cart_items.length === 0)">
            <div class="py-2">
              U heeft op dit moment niets in uw winkelwagen.
            </div>
            <div class="block-content p-0 pt-4 pb-2"></div>
          </div>
          <!-- Messages -->
          <div class="alert alert-danger d-flex align-items-center justify-content-between mb-0" role="alert" v-if="!canpay && !loading">
            <div class="flex-00-auto">
              <i class="fa fa-fw fa-times-circle"></i>
            </div>
            <div class="flex-fill mr-3">
              <p class="mb-0">
                Uw factuurgegevens ontbreken. Klik <a class="alert-link" :href="$route('profile.edit')">hier</a> om deze toe te voegen.
              </p>
            </div>
          </div>

          <div class="block-content" v-if="!$_.isEmpty(cart) && cart && cart.cart_items && cart.cart_items.length > 0">
            <div class="row">
              <div class="col">Totaalbedrag</div>
              <div class="col text-right font-weight-bold">{{ cart.total_excl | currency }}</div>
            </div>
            <div class="row text-primary" v-if="cart.user_discount">
              <div class="col-8">Uw {{ parseInt(cart.user.discount.value) }}% gebruikerskorting</div>
              <div class="col-4 text-right font-weight-bold">- {{ cart.user_discount | currency }}</div>
            </div>
            <template v-if="cart.promocodes.length > 0">
              <hr />
              <div class="row" v-for="promocode in cart.promocodes" :key="promocode.code">
                <div class="col-8">
                  Kortingscode: <b>{{ promocode.code }}</b>
                  <a class="text-muted ml-1" href="javascript:void" v-on:click.prevent="removePromocode(promocode.id)">
                    <i class="fas fa-times-circle"></i>
                  </a>
                </div>
                <div class="col-4 text-right font-weight-bold">- {{ promocode.details['amount'] | currency }}</div>
              </div>
              <div class="my-3 text-danger" v-if="cart.total_promocodes_amount > cart.total_excl_with_discount">
                U heeft nog {{ (cart.total_promocodes_amount - cart.total_excl_with_discount) | currency }} te besteden met uw kortingscode(s). Als u
                nu afrekent komt dit bedrag te vervallen. Voeg nog iets toe aan uw winkelwagen
              </div>
            </template>
            <hr />
            <div class="row">
              <div class="col-8 font-weight-bold">Totaal excl. btw</div>
              <div class="col-4 text-right font-weight-bold">{{ cart.total_excl_with_discount_and_promocodes | currency }}</div>
            </div>
            <hr />
            <div class="row">
              <div class="col">BTW (21%)</div>
              <div class="col text-right font-weight-bold" v-if="!vatfree">{{ cart.total_vat | currency }}</div>
              <div class="col text-right font-weight-bold" v-if="vatfree">Geen</div>
            </div>
            <div class="row align-items-center mb-3">
              <div class="col-8 font-weight-bold">Totaal incl. btw</div>
              <div class="col text-right font-weight-bold">{{ cart.total_incl | currency }}</div>
            </div>
            <div class="form-group">
              <button
                class="btn btn-success btn-block"
                :class="{ 'btn-alt-success': !$_.isEmpty(methods) }"
                v-on:click.prevent="getMethods"
                :disabled="!canpay"
              >
                Afrekenen
              </button>
              <button v-b-modal.cart-promotion-code class="btn btn-sm btn-link text-body font-weight-bold mt-2">
                <i class="fas fa-long-arrow-alt-right"></i>
                Kortingscode invoeren
              </button>

              <bs-cart-promotion-code-modal />
            </div>
          </div>
        </div>
        <transition name="custom-classes-transition" enter-active-class="animated slideInDown faster" leave-active-class="animated bounceOutRight">
          <div class="block block-mode-loading-oneui" v-show="!$_.isEmpty(methods)" :class="{ 'block-mode-loading': loading }">
            <div class="block-header block-header-default">
              <h3 class="block-title">Afrekenen</h3>
            </div>
            <div class="block-content">
              <div class="d-flex justify-content-between pb-3">
                <div
                  class="method"
                  v-for="method in methods"
                  :key="method.id"
                  :class="{ selected: payMethod == method.id }"
                  v-on:click.prevent="payMethod = method.id"
                >
                  <img
                    :src="'/media/payment/' + method.id + '.svg'"
                    class="figure-img img-fluid rounded mx-auto d-block w-100 mb-0"
                    :alt="method.description"
                  />
                  <i class="fas fa-check checkmark"></i>
                </div>
              </div>
              <div class="well pb-3" v-show="payMethod == 'balance'">
                <table class="table table-striped table-vcenter">
                  <tbody>
                    <tr>
                      <td>Saldo:</td>
                      <td>{{ balance | currency }}</td>
                    </tr>
                    <tr id="topay" :class="{ danger: balance < cart.total_incl }">
                      <td>Te betalen:</td>
                      <td>
                        <span class="amountTotal">{{ cart.total_incl | currency }}</span>
                        <!-- <template v-if="vatfree">excl btw</template>
                        <template v-else>incl btw</template> -->
                      </td>
                    </tr>
                    <tr>
                      <td v-show="parseFloat(balance) < cart.total_incl" colspan="2" class="text-danger" id="tolowpay">
                        Saldo te laag <br />
                        Stort {{ (cart.total_incl - parseFloat(balance)) | currency }}
                        <template v-if="vatfree">exclusief btw om deze links te kunnen afrekenen met jouw saldo.</template>
                        <template v-else>inclusief btw om deze links te kunnen afrekenen met jouw saldo.</template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="form-group">
                <button
                  class="btn btn-success btn-block"
                  v-on:click.prevent="order"
                  v-if="payMethod !== 'balance' || (payMethod === 'balance' && parseFloat(balance) >= parseFloat(cart.total_incl))"
                >
                  Betalen
                </button>
                <a v-else href="javascript:void(0)" class="btn btn-alt-primary btn-block" v-on:click="updateCredit"
                  >Direct {{ (cart.total_incl - parseFloat(balance)) | currency }} saldo toevoegen</a
                >
                <div v-if="message" class="d-block invalid-feedback animated fadeIn">{{ message | capitalize }}</div>
              </div>
            </div>
          </div>
        </transition>
        <!-- END Shopping Cart -->
      </div>
      <div class="col-lg-7 col-xl-8">
        <div class="block block-mode-loading-oneui" :class="{ 'block-mode-loading': loading }">
          <div class="block-header block-header-default">
            <h3 class="block-title">Winkelwagen</h3>
          </div>
          <div class="block-content" v-if="$_.isEmpty(cart) || (cart && cart.cart_items && cart.cart_items.length === 0)">
            <div class="py-2">
              U heeft op dit moment niets in uw winkelwagen.
            </div>
            <div class="block-content p-0 pt-4 pb-2"></div>
          </div>
          <div class="block-content p-0 pt-4 pb-2" v-if="!$_.isEmpty(cart)">
            <div class="table-responsive" v-if="cart && cart.cart_items && cart.cart_items.length > 0">
              <table class="js-table-sections table table-vcenter">
                <thead>
                  <tr>
                    <th style="width: 30px;"></th>
                    <th class="font-w700">Pagina</th>
                    <th style="width: 200px">Anchor/Url</th>
                    <th style="width: 200px">
                      Verloopdatum
                      <i
                        class="fas fa-question-circle ml-2"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Dit wordt de definitieve verloopdatum zodra de link vandaag wordt afgerekend voor de door u geselecteerde periode in combinatie met de gekozen startdatum."
                        data-original-title="Dit wordt de definitieve verloopdatum zodra de link vandaag wordt afgerekend voor de door u geselecteerde periode in combinatie met de gekozen startdatum."
                      ></i>
                    </th>
                    <th style="width: 100px">Periode</th>
                    <th style="width: 150px">Bedrag</th>
                    <th class="text-right" style="width: 110px">Acties</th>
                  </tr>
                </thead>
                <template v-for="(group, key) in groups">
                  <tbody class="js-table-sections-header show table-active" :key="key">
                    <tr>
                      <td class="text-center">
                        <i class="fa fa-angle-right text-muted"></i>
                      </td>
                      <td class="font-w600 font-size-sm" colspan="3">
                        <div class="py-1">
                          {{
                            group[0].user_package_id ? `${group[0].type == '1' ? 'Nieuw' : 'Verlenging'} ${group[0].user_package.package.name}` : key
                          }}
                          ({{ group.length }})
                        </div>
                      </td>
                      <td>
                        <bs-select
                          v-if="group[0].user_package_id"
                          :name="'period_' + group[0].id"
                          :empty="false"
                          classname="js-select2"
                          :options="[
                            {
                              value: 1,
                              name: '1 Jaar',
                            },
                            {
                              value: 2,
                              name: '2 Jaar',
                            },
                            {
                              value: 3,
                              name: '3 Jaar',
                            },
                            {
                              value: 4,
                              name: '4 Jaar',
                            },
                            {
                              value: 5,
                              name: '5 Jaar',
                            },
                            {
                              value: 6,
                              name: '6 Jaar',
                            },
                            {
                              value: 7,
                              name: '7 Jaar',
                            },
                            {
                              value: 8,
                              name: '8 Jaar',
                            },
                            {
                              value: 9,
                              name: '9 Jaar',
                            },
                            {
                              value: 10,
                              name: '10 Jaar',
                            },
                          ]"
                          v-model="group[0].period"
                          v-on:input="updateCart(group[0])"
                        ></bs-select>
                      </td>
                      <td>{{ group | sum | currency }}</td>
                      <td class="text-right">
                        <a
                          v-if="group[0].user_package_id"
                          class="text-muted mr-3"
                          href="javascript:void"
                          v-on:click.prevent="removeFromCart(group[0].id)"
                          ><i class="far fa-trash-alt"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                  <tbody class="font-size-sm" :key="key + '_items'">
                    <tr v-for="item in group" :key="item.id">
                      <td class="text-center"></td>
                      <td class="font-weight-bold" v-if="item.site">
                        <div class="pr-2">
                          <div class="font-w600">{{ item.site.name | capitalize }}</div>
                          <small class="text-muted">{{ item.page.title }}</small>
                        </div>
                      </td>
                      <td class="font-weight-bold" v-if="item.blog">{{ item.blog.name }}</td>
                      <td class="font-size-sm d-flex justify-content-between align-items-center">
                        <div class="pr-2">
                          <div class="font-w600">{{ item.title }}</div>
                          <small class="text-muted" v-if="item.url">{{ item.url }}</small>
                        </div>
                      </td>
                      <td>
                        <div v-if="item.blog || item.period > 100">{{ moment(item.start_date) | date }} - n.v.t.</div>
                        <div v-else-if="item.link && moment(item.expired_at).isAfter(moment())">
                          {{ moment(item.link.expired_at) | date }} - {{ moment(item.link.expired_at).add(item.period, 'years') | date }}
                        </div>
                        <div v-else-if="moment(item.start_date).isAfter(moment())">
                          {{ moment(item.start_date) | date }} - {{ moment(item.start_date).add(item.period, 'years') | date }}
                        </div>
                        <div v-else>{{ moment() | date }} - {{ moment().add(item.period, 'years') | date }}</div>
                      </td>
                      <td>
                        <bs-select
                          v-if="!item.user_package_id && !item.blog"
                          :name="'period_' + item.id"
                          :empty="false"
                          classname="js-select2"
                          :disabled="item.user_package_id != null"
                          :options="periodOptions(item)"
                          v-model="item.period"
                          v-on:input="updateCart(item)"
                        ></bs-select>
                      </td>
                      <td class="font-size-sm">
                        <template v-if="!item.user_package_id">
                          <template v-if="item.discount_amount !== item.amount">
                            <del>{{ item.amount | currency }}</del>
                            <span>{{ item.discount_amount | currency }}</span>
                          </template>
                          <template v-else>
                            <span>{{ item.amount | currency }}</span>
                          </template>
                        </template>
                      </td>
                      <td class="text-right">
                        <a v-if="item.blog" class="text-primary mr-3" :href="$route('cart.edit', item.id)"><i class="fas fa-pencil-alt"></i></a>
                        <a class="text-muted mr-3" href="javascript:void" v-if="!item.user_package_id" v-on:click.prevent="removeFromCart(item.id)"
                          ><i class="far fa-trash-alt"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';

export default {
  props: ['balance', 'vatfree', 'canpay'],
  data: () => {
    return {
      methods: {},
      errors: [],
      payMethod: 'ideal',
      message: null,
    };
  },
  computed: {
    ...mapState('cart', ['cart', 'loading']),
    groups: function() {
      if (!this.cart.cart_items) return [];

      let packages = this.cart.cart_items.filter((item) => item.user_package_id);
      let other = this.cart.cart_items.filter((item) => !item.user_package_id);

      return {
        ..._.groupBy(_.sortBy(packages, 'user_package_id'), 'user_package_id'),
        ..._.groupBy(_.sortBy(other, 'type'), 'type_name'),
      };
    },
  },
  watch: {
    cart() {
      setTimeout(() => {
        window.One.helpers(['select2', 'core-bootstrap-tooltip']);
      }, 100);
    },
  },
  filters: {
    sum: function(val) {
      let isPackage = val.some((item) => item.user_package_id);
      if (isPackage) {
        return val[0].user_package.package.price * val[0].period;
      } else {
        return _.sumBy(val, 'discount_amount');
      }
    },
  },
  methods: {
    ...mapActions('cart', ['removeFromCart', 'removePromocode', 'updateCart']),
    periodOptions: function(item) {
      if (item.page_id == 1) {
        return Array(10)
          .fill()
          .map((_, idx) => {
            const value = idx + 1;

            return {
              value: value,
              name: `${value} Jaar`,
            };
          });
      }

      return [
        {
          value: 1,
          name: `1 Jaar`,
        },
        {
          value: 2,
          name: `2 Jaar`,
        },
        {
          value: 3,
          name: `3 Jaar`,
        },
        {
          value: 200,
          name: `Permanent`,
        },
      ];
    },
    updateCredit: function() {
      window.location.href = route('profile.balance') + '?balance=' + (this.cart.total_incl - parseFloat(this.balance)).toFixed(2);
    },
    getMethods: function() {
      this.$store.commit('cart/setLoading', true);
      axios.get(route('cart.methods')).then((response) => {
        if (response.status === 200 && response.data && response.data.success) {
          this.$store.commit('cart/setLoading', false);
          this.methods = response.data.data;
        }
      });
    },
    order: function() {
      this.$store.commit('cart/setLoading', true);
      this.message = null;
      axios
        .post(route('cart.order'), {
          payment: this.payMethod,
        })
        .then((response) => {
          if (response.data) {
            if (response.data.success) {
              this.$store.commit('cart/setLoading', false);
              window.location.href = response.data.redirect;
            } else {
              this.message = response.data.message;
            }
          }
        })
        .finally(() => {
          this.$store.commit('cart/setLoading', false);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.method {
  position: relative;
  width: 18%;
  padding: 10px;
  border: 2px solid #f5f5f5;
  border-radius: 12px;
  cursor: pointer;

  .checkmark {
    display: none;
    position: absolute;
    top: -8px;
    right: -8px;
    width: 20px;
    height: 20px;
    text-align: center;
    background: #28a745;
    color: white;
    font-size: 11px;
    line-height: 20px;
    border-radius: 50%;
  }

  &.selected {
    background: #daf5e6;
    border-color: #28a745;

    .checkmark {
      display: block;
    }
  }
}
</style>
